<template>
  <v-container grid-list-md fluid>
    <v-layout wrap justify-space-between>
      <v-flex xs12 sm2>
        <v-btn
          color="primary"
          @click="create"
          class="mb-4"
          :disabled="!hasCondominioAccess(entity, 'create')"
        >
          {{ this.translate("system.button.add.title") }}
          <v-icon dark>{{ this.translate("system.button.add.icon") }}</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 sm4>
        <v-layout justify-space-between align-left>
          <v-text-field
            append-icon="search" 
            label="Pesquisar"
            v-model="search"
            @keyup.native="keyupSearch"
          ></v-text-field>
          <v-checkbox label="Apenas Ativos" v-model="apenasAtivos" @change="initialize()"/>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm1>
        <v-menu offset-y>
          <v-btn slot="activator" icon class="ml-2" title="Relatórios">
            <v-icon>description</v-icon>
          </v-btn>
          <v-list>
          <!-- PDF -->
          <v-list-tile @click="exportReport(1)">
            <v-list-tile-action>
              <v-icon color="red darken-1">picture_as_pdf</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Relatório em PDF</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- Excel -->
          <v-list-tile @click="exportReport(2)">
            <v-list-tile-action>
              <v-icon color="green darken-2">table_chart</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Relatório em Excel</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        </v-menu>
      </v-flex>

      <!--Index-->
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-1"
          :pagination.sync="pagination"
          disable-initial-sort
          hide-actions
          rows-per-page-text="Registros por página"
          no-data-text="Não existem registros"
          no-results-text="Nenhum registro encontrado"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.sequencia_ir }}</td>
            <td>{{ props.item.id_texto }}</td>
            <td>{{ getCodigoText(props.item.codigo) }}</td>
            <td>{{ props.item.banco }}</td>
            <td>{{ props.item.contrato }}</td>
            <!-- <td>{{ props.item.pessoa.pessoa.id_texto.split(" ")[0] }}</td> -->
            <td>{{ props.item.pessoa && props.item.pessoa.pessoa.id_texto.split(" ")[0] }}</td>
            <td class="text-xs-right">{{ props.item.situacao_anoanterior | formatCurrency }}</td>
            <td class="text-xs-right">{{ props.item.situacao_anobase | formatCurrency }}</td>
            <td>
              <v-checkbox
                v-model="props.item.ativo"
                color="primary"
                @click.native="
                  editValue(entity, props.item.id, {
                    id: props.item['id'],
                    ativo: props.item['ativo'],
                  })
                "
              ></v-checkbox>
            </td>
            <td align="center" style="min-width: 150px">
              <v-btn
                icon
                class="mx-0"
                @click="editItem(props.item)"
                :disabled="!hasCondominioAccess(entity, 'update')"
              >
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mx-0"
                @click="deleteItem(props.item)"
                :disabled="!hasCondominioAccess(entity, 'delete')"
              >
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template v-slot:footer>
            <td colspan="6">
              <strong>Total Geral</strong>
            </td>
            <td align="right">
              <strong>{{ total_situacao_anoanterior | formatCurrency }}</strong>
            </td>
            <td align="right">
              <strong>{{ total_situacao_anobase | formatCurrency }}</strong>
            </td>
          </template>
          <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
        </v-data-table>

        <div
          style="
            border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
            border-left: 1px solid rgba(0, 0, 0, 0.12) !important;
            border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
          "
          class="v-datatable v-table theme--light"
        >
          <div class="v-datatable__actions">
            <div class="v-datatable__actions__select">
              Registros por página
              <v-select
                :items="[25, 50, 75, 100]"
                @change="changePage(pagination['current_page'])"
                v-model="pagination['rowsPerPage']"
                class="v-select__selection v-select__selection--comma"
              ></v-select>
              <!-- <input aria-label="Registros por página" readonly="readonly" type="text" autocomplete="on" aria-readonly="false"> -->
            </div>
            <div class="v-datatable__actions__range-controls">
              <div class="v-datatable__actions__pagination">
                {{ `${this.pagination.from} - ${this.pagination.to} de ${this.pagination.total}` }}
              </div>
              <button
                :disabled="pagination['current_page'] === 1"
                @click="changePage(pagination['current_page'] - 1)"
                type="button"
                :class="
                  pagination['current_page'] === 1
                    ? 'v-btn v-btn--disabled v-btn--flat v-btn--icon theme--light'
                    : 'v-btn v-btn--flat v-btn--icon theme--light'
                "
                aria-label="Previous page"
              >
                <div class="v-btn__content">
                  <i aria-hidden="true" class="v-icon material-icons theme--light">chevron_left</i>
                </div>
              </button>
              <button
                :disabled="pagination['current_page'] === pagination.last_page"
                @click="changePage(pagination['current_page'] + 1)"
                type="button"
                :class="
                  pagination['current_page'] === pagination.last_page
                    ? 'v-btn v-btn--disabled v-btn--flat v-btn--icon theme--light'
                    : 'v-btn v-btn--flat v-btn--icon theme--light'
                "
                aria-label="Next page"
              >
                <div class="v-btn__content">
                  <i aria-hidden="true" class="v-icon material-icons theme--light">chevron_right</i>
                </div>
              </button>
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>

    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1600px" persistent>
      <v-card>
        <v-card-text>
          <v-container grid-list-md fluid>
            <v-layout wrap justify-space-between align-center>
              <v-flex xs12 md6>
                <span class="display-1">{{ formTitle }}</span>
              </v-flex>

              <v-spacer></v-spacer>

              <v-flex xs12 md4>
                <v-checkbox
                  class="m-0"
                  v-model="limitarCaracteres"
                  label="Limitar a quantidade de caracteres"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-center align-center>
              <v-flex xs12>
                <v-text-field
                  name="id_texto"
                  :maxlength="limitarCaracteres == true ? 63 : null"
                  counter
                  data-vv-validate-on="blur"
                  v-model="editedItem.id_texto"
                  v-validate="'required' + (limitarCaracteres == true ? '|max: 63' : '')"
                  :error-messages="errors.collect('id_texto')"
                  :data-vv-as="translate('table.' + entity + '.field.id_texto')"
                  :label="translate('table.' + entity + '.field.id_texto')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-autocomplete
                  name="codigo"
                  v-model="editedItem.codigo"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :error-messages="errors.collect('codigo')"
                  :data-vv-as="translate('table.' + entity + '.field.codigo')"
                  :label="translate('table.' + entity + '.field.codigo')"
                  :items="translate('value.divida_onus_codigo')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  name="sequencia_ir"
                  data-vv-validate-on="blur"
                  counter
                  maxlength="19"
                  v-model="editedItem.sequencia_ir"
                  v-validate="'required'"
                  @blur="checkDuplicate(items, 'sequencia_ir', editedItem.sequencia_ir)"
                  :error-messages="errors.collect('sequencia_ir')"
                  :data-vv-as="translate('table.' + entity + '.field.sequencia_ir')"
                  :label="translate('table.' + entity + '.field.sequencia_ir')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <p-date
                  name="data"
                  data-vv-validate-on="blur"
                  v-model="editedItem.data"
                  v-validate="'required'"
                  :error-messages="errors.collect('data')"
                  :data-vv-as="translate('table.' + entity + '.field.data')"
                  :label="translate('table.' + entity + '.field.data')"
                  :v_validate="'required'"
                  :as="translate('table.' + entity + '.field.data')"
                ></p-date>
              </v-flex>

              <v-flex xs12 md6>
                <v-text-field
                  name="banco"
                  v-model="editedItem.banco"
                  counter
                  maxlength="30"
                  v-validate="'required'"
                  data-vv-validate-on="blur"
                  :error-messages="errors.collect('banco')"
                  :data-vv-as="translate('table.' + entity + '.field.banco')"
                  :label="translate('table.' + entity + '.field.banco')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <p-cpf-cnpj
                  name="cpf_cnpj"
                  v-model="editedItem.cpf_cnpj"
                  v_validate="required"
                  :label="translate('table.' + entity + '.field.cpf_cnpj')"
                ></p-cpf-cnpj>
              </v-flex>

              <v-flex xs12 md4>
                <v-text-field
                  counter
                  maxlength="10"
                  :label="translate('table.' + entity + '.field.contrato')"
                  v-model="editedItem.contrato"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  counter
                  maxlength="30"
                  :label="translate('table.' + entity + '.field.propriedade')"
                  v-model="editedItem.propriedade"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <p-date
                  :label="translate('table.' + entity + '.field.contratacao')"
                  v-model="editedItem.contratacao"
                ></p-date>
              </v-flex>

              <v-flex xs12 md4>
                <v-text-field
                  counter
                  maxlength="30"
                  :label="translate('table.' + entity + '.field.vencimento')"
                  v-model="editedItem.vencimento"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-autocomplete
                  name="condominio_pessoa_id"
                  v-model="editedItem.condominio_pessoa_id"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :error-messages="errors.collect('condominio_pessoa_id')"
                  :data-vv-as="translate('table.' + entity + '.field.condominio_pessoa_id')"
                  :label="translate('table.' + entity + '.field.condominio_pessoa_id')"
                  :items="responsaveis"
                  item-text="pessoa.id_texto"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field
                  name="complemento"
                  counter
                  maxlength="8"
                  label="Complemento"
                  v-model="editedItem.complemento"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md2>
                <p-money
                  name="valor_contrato"
                  :label="translate('table.' + entity + '.field.valor_contrato')"
                  v-model="editedItem.valor_contrato"
                  :v_validate="'positiveNumber|requiredNumber'"
                  :data_vv_as="translate('table.' + entity + '.field.valor_contrato')"
                ></p-money>
              </v-flex>

              <v-flex xs12 md8>
                <span class="headline">Distribuições</span>
              </v-flex>
              <v-flex xs12 md4 class="text-xs-right">
                <v-btn color="primary" @click="createSubItem()" class="my-1">
                  {{ this.translate("system.button.add.title") }}
                  <v-icon dark>{{ this.translate("system.button.add.icon") }}</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12>
                <v-data-table
                  :headers="sub_headers"
                  :items="editedItem.sub_items"
                  id="sub_items_table"
                  hide-actions
                  no-data-text="Não existem registros"
                  no-results-text="Nenhum registro encontrado"
                >
                  <template slot="items" slot-scope="props">
                    <td>
                      <v-autocomplete
                        v-model="props.item.tipo"
                        :items="subItemTipos"
                        item-text="id_texto"
                        item-value="id"
                      ></v-autocomplete>
                    </td>
                    <td>
                      <p-date limitPreviousYears v-model="props.item.data"></p-date>
                    </td>
                    <td>
                      <p-money
                        name="valor_base"
                        v-model="props.item.valor_base"
                        :v_validate="'positiveNumber'"
                        data_vv_as="Pago Principal"
                      ></p-money>
                    </td>
                    <td>
                      <p-money
                        name="juros"
                        v-model="props.item.juros"
                        :v_validate="'positiveNumber'"
                        data_vv_as="Juros e Acessórios"
                      ></p-money>
                    </td>
                    <td>
                      <p-money disabled :value="props.item.valor_base + props.item.juros"></p-money>
                    </td>
                    <td align="center">
                      <v-btn icon class="mx-0" @click="deleteSubItem(props.item)">
                        <v-icon color="pink">delete</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>

              <v-flex xs12 md2>
                <p-money
                  disabled
                  :label="translate('table.' + entity + '.field.valor_liberado')"
                  :value="sum.liberacao"
                ></p-money>
              </v-flex>
              <v-flex xs12 md2>
                <p-money
                  disabled
                  :label="translate('table.' + entity + '.field.valor_pago')"
                  :value="sum.pagamento"
                ></p-money>
              </v-flex>
              <v-flex xs12 md2>
                <p-money
                  disabled
                  :label="translate('table.' + entity + '.field.valor_juros')"
                  :value="sum.juros"
                ></p-money>
              </v-flex>
              <v-flex xs12 md2>
                <p-money
                  disabled
                  :label="translate('table.' + entity + '.field.total_geral')"
                  :value="sum.pagamento + sum.juros"
                ></p-money>
              </v-flex>
              <v-flex xs12 md2>
                <p-money
                  disabled
                  :readonly="true"
                  :label="
                    translate('table.' + entity + '.field.situacao_anoanterior') +
                    ($auth.user().anobase.id_texto - 1)
                  "
                  v-model="editedItem.situacao_anoanterior"
                ></p-money>
              </v-flex>
              <v-flex xs12 md2>
                <p-money
                  name="situacao_anobase"
                  :label="
                    translate('table.' + entity + '.field.situacao_anobase') +
                    $auth.user().anobase.id_texto
                  "
                  v-model="editedItem.situacao_anobase"
                  :v_validate="'positiveNumber'"
                ></p-money>
                <div id="proccess">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <!-- <v-btn flat icon color="blue"  class="ma-0"> -->
                      <v-icon v-on="on" @click="processSituacao">refresh</v-icon>
                    </template>
                    <span>
                      Clique aqui para atualizar este campo com base nos valores já lançados.
                    </span>
                  </v-tooltip>
                </div>
              </v-flex>

              <v-flex xs12>
                <v-switch
                  color="primary"
                  :label="translate('table.' + entity + '.field.ativo')"
                  v-model="editedItem.ativo"
                ></v-switch>
              </v-flex>
              <v-flex xs12>
                <v-btn
                  class="mx-1"
                  color="primary darken-2"
                  :disabled="saving"
                  :loading="saving"
                  @click.native="save(entity, editedItem.id, editedItem, 1, true)"
                >
                  Salvar
                </v-btn>
                <v-btn class="mx-1" @click.native="close(400)">Cancelar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
#sub_items_table {
  border-radius: 4px;
  border: 1px solid #bbb;
  margin-bottom: 4px;
}

#sub_items_table .custom-height {
  padding-top: 8px !important;
}

td .custom-height {
  padding-top: 6px;
  display: flex;
  align-items: center;
}

#proccess {
  position: absolute;
}

#proccess .v-icon {
  position: relative;
  bottom: 50px;
  left: 153px;
}
</style>

<script>
import crud from "./../../mixin/crud";
import PDate from "../shared/PDate";
import PMoney from "../shared/PMoney";
import mask from "./../../mixin/mask";
import Helper from "./../../classes/helper";
import acl from "./../../mixin/acl";
import PCpfCnpj from "../shared/PCpfCnpj";

export default {
  components: {
    PDate,
    PMoney,
    PCpfCnpj,
  },
  mixins: [crud, mask, acl],
  data: () => ({
    entity: "condominio_dividaonusrural",
    subItemTipos: [
      { id: "pagamento", id_texto: "Pagamento" },
      { id: "liberacao", id_texto: "Liberação" },
    ],
    items: [],
    pagination: { rowsPerPage: 25, sortBy: "", descending: false },
    page: 1,
    setKeyup: null,
    total_situacao_anobase: 0,
    total_situacao_anoanterior: 0,
    limitarCaracteres: true,
    apenasAtivos: true,
  }),
  name: "DividaOnusRural",
  props: ["condominio_id", "initials", "responsaveis", "particular"],
  created() {
    this.initialize();
    let anobaseId = this.$auth.user().anobase.id;
    this.editedItem = {
      condominio_id: this.condominio_id,
      sequencia_ir: "",
      ativo: true,
      anobase_id: anobaseId,
      situacao_anobase: 0,
      situacao_anoanterior: 0,
      valor_contrato: 0,
      valor_pago: 0,
      sub_items: [],
      cpf_cnpj: "",
    };
    this.defaultItem = {
      condominio_id: this.condominio_id,
      sequencia_ir: "",
      ativo: true,
      anobase_id: anobaseId,
      situacao_anobase: 0,
      situacao_anoanterior: 0,
      valor_contrato: 0,
      valor_pago: 0,
      sub_items: [],
      cpf_cnpj: "",
    };
    sequencia_ir_duplicated: false;
  },
  computed: {
    headers: function () {
      return [
        {
          text: this.translate("table." + this.entity + ".field.sequencia_ir"),
          value: "sequencia_ir",
          width: "10%",
        },
        {
          text: this.translate("table." + this.entity + ".field.id_texto"),
          value: "id_texto",
          width: "40%",
        },
        {
          text: this.translate("table." + this.entity + ".field.codigo"),
          value: "codigo",
          width: "5%",
        },
        {
          text: this.translate("table." + this.entity + ".field.banco"),
          value: "banco",
          width: "15%",
        },
        {
          text: this.translate("table." + this.entity + ".field.contrato"),
          value: "contrato",
          width: "5%",
        },
        {
          text: this.translate("table." + this.entity + ".field.condominio_pessoa_id"),
          value: "contrato",
        },
        {
          text:
            this.translate("table." + this.entity + ".field.situacao_anoanterior") +
            (this.$auth.user().anobase.id_texto - 1),
          value: "situacao_anoanterior",
          width: "10%",
          align: "right",
        },
        {
          text:
            this.translate("table." + this.entity + ".field.situacao_anobase") +
            this.$auth.user().anobase.id_texto,
          value: "situacao_anobase",
          width: "10%",
          align: "right",
        },
        {
          text: this.translate("table." + this.entity + ".field.ativo"),
          value: "ativo",
          width: "5%",
        },
        {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          width: "5%",
          align: "center",
        },
      ];
    },
    sub_headers: function () {
      return [
        {
          text: this.translate("table." + this.entity + "_item.field.tipo"),
          sortable: false,
          value: "tipo",
        },
        {
          text: this.translate("table." + this.entity + "_item.field.data"),
          sortable: false,
          value: "data",
        },
        {
          text: this.translate("table." + this.entity + "_item.field.valor_base"),
          sortable: false,
          value: "valor_base",
        },
        {
          text: this.translate("table." + this.entity + "_item.field.juros"),
          sortable: false,
          value: "juros",
        },
        {
          text: this.translate("table." + this.entity + "_item.field.valor_total"),
          sortable: false,
          value: "valor_total",
        },
        {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
    sum() {
      return this.editedItem.sub_items.reduce(
        (acc, cur) => {
          acc.juros += cur.juros;
          acc[cur.tipo] += cur.valor_base;
          return acc;
        },
        { pagamento: 0, liberacao: 0, juros: 0 }
      );
    },
  },
  methods: {
    checkDuplicate(items, index, value) {
      // this.sequencia_ir_duplicated = items.find((item) => {
      //   return item[index] === value;
      // });
      // if (this.sequencia_ir_duplicated) {
      //   event.preventDefault();
      //   event.target.select();
      // }
    },
    afterSave() {
      this.initialize();
    },
    afterDelete() {
      this.initialize();
    },
    initialize() {
      this.$store.commit("loader/change_dialog", true);
      let params = {
        search: this.search,
        apenasAtivos: this.apenasAtivos,
        page: this.pagination["current_page"] ? this.pagination["current_page"] : 1,
        perPage: this.pagination["rowsPerPage"] ? this.pagination["rowsPerPage"] : 25,
        desc: this.pagination["descending"] ? this.pagination["descending"] : false,
        sort: this.pagination["sortBy"] ? this.pagination["sortBy"] : "sequencia_ir",
        condominio_id: this.condominio_id ? this.condominio_id : 0,
      };
      this.$http.post(`api/paginate_dividaonusrural`, params).then(
        (res) => {
          this.total_situacao_anoanterior = res.body.total_situacao_anoanterior;
          this.total_situacao_anobase = res.body.total_situacao_anobase;

          let resbody = res.body.dados;

          this.items = resbody.data;

          Object.assign(this.pagination, {
            total: resbody.total,
            rowsPerPage: resbody.per_page,
            current_page: resbody.current_page,
            last_page: resbody.last_page,
            from: resbody.from,
            to: resbody.to,
          });
          this.$store.commit("loader/change_dialog", false);
        },
        (err) => {
          this.$store.commit("snackbar/change_values", {
            text: "Não foi possível carregar os dados.",
            color: "error",
            dialog: true,
          });
          this.$store.commit("loader/change_dialog", false);
        }
      );
    },
    keyupSearch(key) {
      // caso o usuario fique 2 segundo sem digitar e feita uma busca da pagina novamente
      clearTimeout(this.setKeyup);
      if (key["key"] === "Enter") {
        this.initialize();
      } else {
        this.setKeyup = setTimeout(() => {
          this.initialize();
        }, 2000);
      }
    },
    changePage(page = 1) {
      this.pagination["current_page"] = page;
      this.initialize();
    },
    afterInitialize() {
      this.paises = this.resBody.paises;
    },
    afterEdit() {
      this.limitarCaracteres = this.editedItem.id_texto.length <= 63;
      this.editedItem.sub_items = this.editedItem.situacao_atual[0].distribuicoes;
    },
    beforeCreate() {
      this.$http.post(`api/get_max_sequence_dividaonusrural/${this.condominio_id}`).then(
        (res) => {
          let maxSequence = res.body;
          maxSequence = Helper.pad(++maxSequence, 5);
          this.editedItem.sequencia_ir = `${
            this.initials ? this.initials + "-" : ""
          }DR-${maxSequence}`;
        },
        (err) => {
          this.$store.commit("snackbar/change_values", {
            text: "Não foi possível carregar a sequencia.",
            color: "error",
            dialog: true,
          });
        }
      );
    },
    beforeSave() {
      this.editedItem.valor_pago = this.sum.pagamento;
      this.editedItem.valor_liberado = this.sum.liberacao;

      this.editedItem.sub_items = this.editedItem.sub_items.map((item) => {
        item.valor_total = item.valor_base + item.juros;
        return item;
      });
    },
    createSubItem: function () {
      this.editedItem.sub_items.push({
        tipo: "pagamento",
        data: "",
        valor_base: 0,
        juros: 0,
        valor_total: 0,
      });
    },
    deleteSubItem(item) {
      const index = this.editedItem.sub_items.indexOf(item);
      this.editedItem.sub_items.splice(index, 1);
    },
    processSituacao() {
      const { liberacao, pagamento } = this.sum;
      this.editedItem.situacao_anobase =
        this.editedItem.situacao_anoanterior + liberacao - pagamento;
    },
    getCodigoText (codigo) {
      const item = this.translate('value.divida_onus_codigo').find(c => c.value === codigo)
      return item ? item.text : ''
    },
    // type 1 = pdf 2 = excel
    exportReport (type) {
      this.$store.commit("loader/change_dialog", true);
      this.$http.put(`report/report_details/${this.condominio_id}`, {"type": type, "table": "condominio_dividaonusrural", "search": this.search, "apenasAtivos": this.apenasAtivos}).then(
        (res) => {
          let fileName = res.data;
          window.open(process.env.API + "reports/" + fileName, "_blank");
          this.$store.commit("loader/change_dialog", false);
          setTimeout(function () {
            _this.$http.delete(`report/delete_upload_report/${fileName}`)
          }, 5000)
        },
        (error) => {
          this.$store.commit("loader/change_dialog", false);
          this.$store.commit("snackbar/change_values", {
            text:
              error.body.message ||
              "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
            color: "error",
            dialog: true,
          });
        }
      );
    }
  },
  watch: {
    pagination: {
      handler(a, b) {
        // caso tenha trocado a ordenação busca novamente
        if (a.descending !== b.descending || a.sortBy !== b.sortBy) {
          this.initialize();
        }
      },
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/details/DividaOnusRural.vue